
@if (!isAmountInputInvalid()) {
  <div
    class="badge-yellow" id="bonus-value">
    <span class="icon icon-gift-2"></span>
    @if (!giftAmount) {
      <p class="no-margin text-left" i18n="giftInformation">
    Doładuj za <strong>{{ GIFT_AMOUNT_THRESHOLD }} zł lub więcej</strong> i&nbsp;odbierz prezent</p>
      }
      @if (giftAmount) {
        <p class="no-margin text-left" i18n="giftAddedInformation">
    <strong>Otrzymujesz bonus {{ giftAmount }} zł</strong> do wykorzystania na rozmowy i SMS-y</p>
        }
      </div>
    }
